import { useEffect, useRef, useState } from 'react';
import Navbar from '../Miscellaneous/Navbar';
import BackGroImg from '../Miscellaneous/BackGroImg';
import Footer from '../Miscellaneous/Footer';
import Navbar2 from '../Miscellaneous/Navbar2';
import SweetToastInline from '../Miscellaneous/SweetToastInline';
import RateList from '../Miscellaneous/RateList';
const Menu = () => {
  document.title = "Menu - Roop Sweets";
  const trendingRef = useRef(null);

  const moveToUp = () => {
    window.scrollTo({
      top: 500,
      behavior: 'smooth'
    });
  }

  useEffect(() => {
    const handleScroll = () => {
      const bgElement = document.querySelector('.contactBG');
      const screenWidth = window.innerWidth;

      if (bgElement) {
        const scrollPosition = window.scrollY;

        if (screenWidth <= 500) {
          bgElement.style.backgroundPosition = `center ${scrollPosition * 0.5}px`;
        } else {
          bgElement.style.backgroundPosition = `center ${scrollPosition * -0.5}px`;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      },
      { threshold: 0.5 }
    );

    if (trendingRef.current) {
      observer.observe(trendingRef.current);
    }

    return () => {
      if (trendingRef.current) {
        observer.unobserve(trendingRef.current);
      }
    };
  }, []);

  return (
    <>
      <Navbar />

      
      <div className="contactBG">
        
        <div className='menuInsdiv'>
          <img className='menuIns' src="/images/bg3.png" alt="" />
          <div className='contactdivQuote'>
            <h3 className='quote'>Dil Ki Baat Zubaan Pe Aai 
              <br />
              Jab Khayi
              <span className='roopkimithai'> Roop Ki Mithai</span> 
              <span><img className='heart' src="/images/heart.png" alt="" /></span></h3>
          </div>
        </div>
      </div> 
   

      {/* <div className='linesdiv'>
        <hr />
        <hr />
      </div> */}

      {/* <SweetToastInline />        Shows IMARTI poster */}

      {/* <RateList/> */}

      <div onClick={moveToUp} className='movetoUpImgdiv'>
        <img className='movetoUpImg' src="/images/arrow.png" alt="" />
      </div>

      <div className='menuouterdiv'>
        <Navbar2 />
      </div>

      <BackGroImg />
      <Footer />
    </>
  );
};

export default Menu;
